import { render, staticRenderFns } from "./NoResultsFound.vue?vue&type=template&id=2295deed&scoped=true&"
import script from "./NoResultsFound.vue?vue&type=script&lang=js&"
export * from "./NoResultsFound.vue?vue&type=script&lang=js&"
import style0 from "./NoResultsFound.vue?vue&type=style&index=0&id=2295deed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295deed",
  null
  
)

export default component.exports